import React, { useCallback, useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import DotsIcon from '../../../../icons/DotsIcon'
import "./style.scss"
import DownalodBlueIcon from '../../../../icons/DownalodBlueIcon'
import { formatDateString } from '../../../../constants/date'
import { useDispatch, useSelector } from 'react-redux'
import { getSubscriptionHistory } from '../../../data/redux/pricing/_pricingAction'
import { apiPageLimit, capitalizeFullName } from '../../../../constants/common'
import { CommonPagination } from '../../common/CommnPagination'

interface HistoryTabProps {
  activeTab?: string;
}

const HistoryTab: React.FC<HistoryTabProps> = ({ activeTab }) => {
  const dispatch: any = useDispatch();

  // const [billingHistory, setBillingHistory] = useState<any>();


  const historyDetails = useSelector((state: any) => state?.pricing);
  const billingHistory = historyDetails?.historyList || [];
  const totalCount = historyDetails?.totalCount || 0;

  const [page, setPage] = useState<number>(1);
  const pageSize = apiPageLimit;


  useEffect(() => {
    if (activeTab === "History") {
      dispatch(getSubscriptionHistory({}))
      // getBillingHistory();
    }
  }, [activeTab]);


  // Fetch data with debounce
  const fetchBillingHistory = useCallback(
    // debounce(
    (page: number) => {
      const params: any = { page, limit: pageSize };
      dispatch(getSubscriptionHistory(params));
    },
    //   500
    // ),
    [dispatch]
  );

  // Run when searchTerm or selected changes
  useEffect(() => {
    fetchBillingHistory(page);
  }, [page, fetchBillingHistory]);

  const totalPages = Math.ceil(totalCount / pageSize);

  // const getBillingHistory = async () => {
  //   try {
  //     const response = await dispatch(getSubscriptionHistory());
  //     setBillingHistory(response?.payload?.data?.transactions);
  //     return;
  //   } catch (error) {
  //     console.error("Failed to fetch payment methods:", error);
  //   }
  // };

  const handleDownload = (url: string) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className='billing-history'>
      <div className='title_desc'>
        <h3>Billing History</h3>
        <p>View and download your past invoices</p>
      </div>

      <div className='historyTable'>
        <Table bordered responsive >
          <thead>
            <tr>
              <th>Date</th>
              <th>Plan</th>
              <th>Amount</th>
              <th>Card</th>
              <th>Payment Status</th>
              <th>Plan Status</th>
              <th>Invoice</th>
            </tr>
          </thead>
          <tbody>

            {billingHistory?.length > 0 && billingHistory?.map((item: any, index: number) => {
              return (
                <tr>
                  <td>{formatDateString(item.created_at)}</td>
                  <td>{item?.plan_name}</td>
                  <td>${item?.price}</td>
                  <td>
                    {item?.card?.last4 && (
                      <span> <DotsIcon /> {item?.card?.last4}</span>
                    )}
                  </td>
                  <td><span className='paid'>{item?.status == "active" ? "Paid" : capitalizeFullName(item?.status)}</span></td>
                  <td>{capitalizeFullName(item?.subscription_status)}</td>
                  <td>
                    <button
                      className='download_btn'
                      onClick={() => handleDownload(item?.invoice_url)}
                    >
                      <DownalodBlueIcon /> Download
                    </button>
                  </td>
                </tr>
              )
            })}

          </tbody>
        </Table>
      </div>


      {/* Pagination */}
      <CommonPagination
        currentPage={page}
        totalPages={totalPages}
        onPageChange={setPage}
      />
    </div>
  )
}

export default HistoryTab